import React, { useState } from "react";

import CustomTable from "../../../../customComponents/CustomTable";
import DownloadIcon from "../../../../../Assets/icons/download.svg";
import searchIcon from "../../../../../Assets/icons/searchicon.svg";

import "./listPage.scss";
import ListLogisticsFilters from "../../../Logistics/LogisticsFilter";

const ListPage = ({
  searchplaceholder="",
  isButtonRequired = true,
  isFilterRequired= false,
  isAddButtonRequired = true,
  isDownloadRequired = true,
  isUploadButtonRequired,
  headerTopText = "",
  headerTitle = "",
  addButtonTitle = "Add",
  uploadButtonTitle = "Upload",
  listTitle = "",
  topDetailsList = [],
  tableData = [],
  tableHeaders = [],
  keyMapping = {},
  itemsPerPage = 10,
  handleOnAddButton = () => {},
  handleOnUploadButton = () => {},
  handleViewButton = () => {},
  onEdit = () => {},
  handlePageChange = () => {},
  currentPage,
  totalPages,
  totalRecords,
  filterInputs,
  handleFormSubmit,
  filterFormData,
  setFilterFormData,
  validationErrors,
  setValidationErrors,
  handleClear,
  searchQuery,
  setSearchQuery,
  handleKeyPress=()=>{},
  apiCallFunction=()=>{},
  fetchDepartments=()=>{}
  
}) => {
  console.log("tableData",totalRecords);
  
  const [selectedDurationFilter, setSelectedDurationFilter] = useState(null);

  // const durationFilterTabList = [
  //   { id: 1, title: "This Month" },
  //   { id: 2, title: "Last 3 Months" },
  //   { id: 3, title: "Last 6 Months" },
  //   { id: 4, title: "Last Year" },
  // ];
  console.log("totalRecords",totalRecords);
   const handleSearchChange = (e) =>{
    setSearchQuery(e.target.value)
  }

  const cardsList = [
    {
      id: 1,
      iconDoc: require("../../../../../Assets/icons/dollarDoc.svg"),
      upArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      downArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      title: "Total Invoice",
      value: "₹48,00000",
      showingValueFor: "This month",
      isValueIncreased: 1,
      incrementDecrementPercentage: 2,
    },
    {
      id: 2,
      iconDoc: require("../../../../../Assets/icons/dollarDoc.svg"),
      upArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      downArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      title: "Invoice Sent",
      value: "₹45,00000",
      showingValueFor: "This month",
      isValueIncreased: 1,
      incrementDecrementPercentage: 2,
    },
    {
      id: 3,
      iconDoc: require("../../../../../Assets/icons/dollarDoc.svg"),
      upArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      downArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      title: "Invoice Paid",
      value: "₹38,00000",
      showingValueFor: "This month",
      isValueIncreased: 1,
      incrementDecrementPercentage: 2,
    },
    {
      id: 4,
      iconDoc: require("../../../../../Assets/icons/dollarDoc.svg"),
      upArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      downArrow: require("../../../../../Assets/icons/arrow-up 1.svg"),
      title: "Invoice Pending",
      value: "₹7,00000",
      showingValueFor: "This month",
      isValueIncreased: 0,
      incrementDecrementPercentage: 2,
    },
  ];
  return (
    <div className="row">
      <div className="col-12 listTopContainer">
        <div className="col-12 listMainContainer">
          <div className="col-2 listMainTitleContainer">
            <div className="listTitleHead">{headerTopText || ""}</div>
            <h5 className="listTitleText mt-1">{headerTitle || ""}</h5>
          </div>
          <div className="col-7 d-flex justify-content-between listTopCentreDataContainer">
            {topDetailsList?.length > 0 &&
              topDetailsList?.map((details, index) => (
                <>
                  <div
                    key={details?.id || index}
                    className="listTopDataContainer"
                  >
                    <div className="listTopDataValueText">
                      {details?.value || 0}
                    </div>
                    <div>{details?.title || 0}</div>
                  </div>
                  {index + 1 < topDetailsList?.length && (
                    <div className="listSideBorder" />
                  )}
                </>
              ))}
          </div>

          {/* {isButtonRequired && (
            <div className=" d-flex justify-content-end listTopButtonsContainer">
              {isAddButtonRequired && (
                <button
                  className="listAddButtonStyle m-2 py-2 px-3"
                  onClick={handleOnAddButton}
                >
                  {addButtonTitle || ""}
                </button>
              )}
              {isUploadButtonRequired && (
                <button
                  className="listUploadButtonStyle m-2 py-2 px-3"
                  onClick={handleOnUploadButton}
                >
                  {uploadButtonTitle || ""}
                </button>
              )}
            </div>
          )} */}
        </div>
        {/* {durationFilterTabList?.length > 1 && (
          <div className="listTabContainer col-12">
            <div className="col-12 d-flex align-items-center flex-row flex-wrap mb-3">
              {(durationFilterTabList || []).map((tabDetails, index) => (
                <button
                  key={tabDetails?.id || index}
                  className={
                    tabDetails?.id === selectedDurationFilter?.id
                      ? "listDurationActiveTab ms-1 me-1 px-5 py-3"
                      : "listDurationInactiveTab ms-1 me-1 px-5 py-3"
                  }
                  onClick={() => setSelectedDurationFilter(tabDetails)}
                >
                  {tabDetails?.title || ""}
                </button>
              ))}
            </div>
          </div>
        )} */}
        {
          isFilterRequired && (
            <ListLogisticsFilters 
            formConfig={filterInputs} 
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            handleSearch={handleFormSubmit} 
            handleClear={handleClear}
            />
          )
        }
      </div>

      <div className="listTableContainer mt-2">
        <div className="listTableTopComponentContainer">
          <div className="listSearchBarContainer">
            <h5>{listTitle || ""} </h5>
            <div className="searchinput-wrapper">
              <input
                type='text'
                className='searchinput'
                placeholder={searchplaceholder}
                value={searchQuery}
                onChange={(e) => {
                  handleSearchChange(e); 
                  console.log("keyname",e.key);
                  
                  if (e.key === 'Enter') {
                    apiCallFunction(0, 10, searchQuery); 
                  }
                  if (e.target.value === "") {
                    apiCallFunction(); 
                  }
                }}
                onKeyPress={handleKeyPress}

             
              />
              <img src={searchIcon} alt="Search" className="searchinput-icon" />
            </div>
          </div>
          {isButtonRequired && (
            <div className=" d-flex justify-content-end listTopButtonsContainer">
              {isAddButtonRequired && (
                <button
                  className="listAddButtonStyle addFormButton m-2 px-3"
                  onClick={handleOnAddButton}
                >
                  {addButtonTitle || ""}
                </button>
              )}
              {isUploadButtonRequired && (
                <button
                  className="listUploadButtonStyle m-2 py-2 px-3"
                  onClick={handleOnUploadButton}
                >
                  {uploadButtonTitle || ""}
                </button>
              )}
            </div>
          )}

        </div>

        <CustomTable
          data={tableData}
          headers={tableHeaders}
          keyMapping={keyMapping}
          itemsPerPage={itemsPerPage}
          handleViewButton={handleViewButton}
         
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onEdit={onEdit} 
          totalRecords={totalRecords} 
        />
      </div>
    </div>
  );
};

export default ListPage;
